
import { WorldCountry } from '../types';
import { moroccoExpanded } from './moroccoExpansion';

export const africaExpansion3: WorldCountry[] = [
  moroccoExpanded
];
